import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HiringPage } from "@/features/hiring/HiringPage";

const search = z.object({
  tab: z.enum(["all", "open", "draft", "closed"]).optional(),
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/hiring/")({
  validateSearch: search,
  component: () => <HiringPage search={Route.useSearch()} />,
});
